import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';

@Component({
    selector: 'kt-formly-field-input',
    template: `
    <input inputTrim
      *ngIf="type !== 'number'; else numberTmp"
      [type]="type"
      [formControl]="formControl"
      class="form-control"
      [formlyAttributes]="field"
      [class.is-invalid]="showError"
      [attr.aria-describedby]="id + '-formly-validation-error'"
      [attr.aria-invalid]="showError"
    />
    <ng-template #numberTmp>
      <input
        appNoScroll
        type="number"
        [formControl]="formControl"
        class="form-control"
        [formlyAttributes]="field"
        [class.is-invalid]="showError"
        [attr.aria-describedby]="id + '-formly-validation-error'"
        [attr.aria-invalid]="showError"
      />
    </ng-template>
`,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class FormlyFieldInputComponent extends FieldType<FieldTypeConfig> {
  get type() {
    return this.props.type || 'text';
  }
}
